const nestedGroups = `
  ...GroupFragment
  subGroups {
    ...GroupFragment
    subGroups {
      ...GroupFragment
      subGroups {
        ...GroupFragment
        subGroups {
          ...GroupFragment
          subGroups { id }
        }
      }
    }
  }
`;

export default nestedGroups;
